import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';
import { getProfileStatus, getDashboardPath } from '../utils/profileCheck';
import StudentProfileForm from '../components/forms/StudentProfileForm';
import ParentProfileForm from '../components/forms/ParentProfileForm';
import TeacherProfileForm from '../components/forms/TeacherProfileForm';


const ProfileSetup = () => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('=== PROFILE SETUP PAGE LOADED ===');
    
    // For testing: check localStorage for testRole
    const testRole = localStorage.getItem('testRole');
    console.log('Test role from localStorage:', testRole);
    
    // Check signup role from localStorage
    const signupRole = localStorage.getItem('signupRole');
    console.log('Signup role from localStorage:', signupRole);
    
    if (testRole) {
      console.log('Using test role:', testRole);
      setRole(testRole);
      setLoading(false);
      return;
    }
    const fetchRole = async () => {
      console.log('Fetching role from Supabase session...');
      setLoading(true);
      setError('');
      let redirecting = false;
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) throw error;
        console.log('Session data:', session);
        
        if (!session || !session.user) {
          console.log('No active session found, using localStorage role...');
          // Use localStorage role (from signup)
          const fallbackRole = signupRole || 'Student';
          console.log('Using localStorage role:', fallbackRole);
          setRole(fallbackRole);
          setLoading(false);
          return;
        }
        
        const userRole = session.user.user_metadata?.role;
        console.log('Role from user metadata:', userRole);

        // Don't let someone who already has a profile fill the form in again
        const checkRole = signupRole || userRole || 'Student';
        const profileStatus = await getProfileStatus(session.user.id, checkRole, session.user.email);
        if (profileStatus === 'exists') {
          const dashboardPath = getDashboardPath(checkRole);
          if (dashboardPath) {
            console.log('✅ Profile already exists, redirecting to', dashboardPath);
            redirecting = true;
            window.location.replace(dashboardPath);
            return;
          }
        }
        if (profileStatus === 'error') {
          throw new Error("We couldn't check whether your profile already exists. Please refresh the page to try again.");
        }
        
        // Prioritize signupRole from localStorage over Supabase metadata
        if (signupRole) {
          console.log('Using signupRole from localStorage (prioritized):', signupRole);
          setRole(signupRole);
        } else if (!userRole) {
          console.log('No role in metadata, using default');
          setRole('Student');
        } else {
          console.log('Using role from session:', userRole);
          setRole(userRole);
        }
      } catch (err) {
        console.error('Error fetching role:', err.message);
        console.log('Using localStorage fallback due to error');
        const fallbackRole = signupRole || 'Student';
        setRole(fallbackRole);
        setError(err.message);
      } finally {
        // Keep showing the loading text while redirecting so the form never flashes up
        if (!redirecting) setLoading(false);
      }
    };
    fetchRole();
  }, []);

  if (loading) return <div>Loading profile setup...</div>;
  if (error) return <div style={{ color: 'red' }}>{error}</div>;

  console.log('=== RENDERING PROFILE SETUP ===');
  console.log('Final role being used:', role);
  console.log('Will render form for:', role);
  console.log('=====================================');

  return (
    <div>
      {role === 'Student' && <StudentProfileForm />}
      {role === 'Parent' && <ParentProfileForm />}
      {role === 'Teacher' && <TeacherProfileForm />}
      {role !== 'Student' && role !== 'Parent' && role !== 'Teacher' && <div>Unknown role: {role}</div>}
    </div>
  );
};

export default ProfileSetup;